var app = angular.module('leonardo');

var CategoryNameFilter = function (CategoryRestService) {

  return function (categoryId) {
    if (!categoryId) return 'Not specified yet';
    var list = CategoryRestService.getCollection();
    var name = '';
    angular.forEach(list, function(item) {
      if (item.id == categoryId) name = item.name;
    });
    return name;
  }
};

app.filter('categoryName', ['CategoryRestService', CategoryNameFilter]);
